__turbopack_context__.v({
  "mezzanine_video_initializer": "RvZp-W_mezzanine_video_initializer",
  "mezzanine_video_initializer_image": "RvZp-W_mezzanine_video_initializer_image",
  "mezzanine_video_initializer_placeholder": "RvZp-W_mezzanine_video_initializer_placeholder",
});
